(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const positions = new Map();
  const placeStories = () => {
    for (const [wrapper, marker] of positions) {
      if (!wrapper.isConnected) {
        const replacement = wrapper.id ? document.getElementById(wrapper.id) : null;
        if (marker.isConnected && replacement?.parentElement.id === 'MainContent' && replacement.querySelector('[data-ic-stories]')) {
          positions.delete(wrapper);
          positions.set(replacement, marker);
        } else if (!marker.isConnected || !window.Shopify?.designMode) {
          marker.remove();
          positions.delete(wrapper);
        }
      }
    }
    if (!document.body.classList.contains('ic-template-index')) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const featured = main.querySelector('.ic-featured-collection--promotion')?.closest('.shopify-section');
    const finder = main.querySelector('.ic-fit-teaser')?.closest('.shopify-section');
    main.querySelectorAll('[data-ic-stories]').forEach(section => {
      const wrapper = section.closest('.shopify-section');
      if (!wrapper || wrapper.parentElement !== main) return;
      let marker = positions.get(wrapper);
      if (!marker?.isConnected) {
        marker = document.createComment('ic-story-desktop-position');
        wrapper.before(marker);
        positions.set(wrapper, marker);
      }
      const moved = mobile.matches && featured?.parentElement === main && finder?.parentElement === main && Boolean(featured.compareDocumentPosition(finder) & Node.DOCUMENT_POSITION_FOLLOWING);
      const preceding = moved ? featured : marker;
      if (preceding.nextSibling === wrapper) return;
      wrapper.querySelectorAll('dialog[open]').forEach(dialog => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        dialog.close();
      });
      preceding.after(wrapper);
    });
  };
  let pendingPlacement = 0;
  const schedulePlacement = () => {
    cancelAnimationFrame(pendingPlacement);
    pendingPlacement = requestAnimationFrame(placeStories);
  };
  const bind = root => root.querySelectorAll('[data-ic-stories]').forEach(section => {
    if (section.dataset.icStoriesBound) return;
    section.dataset.icStoriesBound = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const dialogs = [...section.querySelectorAll('[data-ic-story-dialog]')];
    const openers = new Map();
    section.querySelectorAll('[data-ic-story-open]').forEach(link => {
      const dialog = dialogs.find(item => item.id === link.dataset.icStoryOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openers.set(dialog, link);
        dialog.showModal();
        document.body.classList.add('ic-locked');
        const video = dialog.querySelector('video');
        if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
      }, options);
    });
    dialogs.forEach(dialog => {
      dialog.querySelector('[data-ic-story-close]')?.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        if (!document.querySelector('dialog[open]') && !document.body.classList.contains('ic-header-open')) document.body.classList.remove('ic-locked');
        const opener = openers.get(dialog);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      }, options);
    });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(section)) return;
      dialogs.forEach(dialog => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        if (dialog.open) dialog.close();
      });
      if (!document.querySelector('dialog[open]') && !document.body.classList.contains('ic-header-open')) document.body.classList.remove('ic-locked');
      controller.abort();
    }, options);
  });
  bind(document);
  placeStories();
  mobile.addEventListener('change', schedulePlacement);
  document.addEventListener('shopify:section:load', event => {
    bind(event.target);
    schedulePlacement();
  });
  document.addEventListener('shopify:section:unload', schedulePlacement);
  document.addEventListener('shopify:section:reorder', event => {
    const wrapper = event.target.closest('.shopify-section');
    const marker = positions.get(wrapper);
    if (marker) {
      marker.remove();
      positions.delete(wrapper);
    }
    schedulePlacement();
  });
})();

